import { BlossomRenderer } from "./BlossomRenderer";
import { flexComponentMap } from "../FlexComponents/flexComponentMap";
import { FlexComponent } from "src/typings/flexFramework/FlexComponent";
import { BlossomComponentsFactory } from "components/flexFramework/domain/BlossomComponentsFactory";

/**
 * Represents a Blossom Renderer derived from a Flex Composition data source.
 *
 * It should know how to render a list of Blossom Components who are also derived from the Composition.
 */
export class BlossomRendererWithComposition extends BlossomRenderer {
  public constructor(flexComponents: FlexComponent[], isInsideTabGroup = false) {
    const blossomComponents = BlossomComponentsFactory.get({ flexComponents, isInsideTabGroup });
    super(flexComponentMap, blossomComponents);
  }
}
